export const profitLabels = ['Profit', 'Purchase Price', 'Additional Costs'];

export const minDuration = 6;
